import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { InboxStackIcon } from '@heroicons/react/24/outline';

import { AddBoxDialog } from './AddBoxDialog';
import { CategoriesBox } from './CategoriesBox';
import { getStockages } from 'src/service/stockageApi';

export const Stockage = () => {
  const [stockage, setStockage] = useState([]);
  const [filteredStockage, setFilteredStockage] = useState([]);
  const [addBox, setAddBox] = useState();
  const [filterValue, setFilterValue] = useState(null);
  const history = useNavigate();

  useEffect(() => {
    getStockages("?motherBox=1").then((resp) => {
      resp.sort((a, b) => a.boxName.localeCompare(b.boxName))
      setStockage(resp);
      setFilteredStockage(resp);
    });
  }, [addBox]);

  const handleClick = id => {
    history("/dashboard/stockage/" + id);
  }

  const handleClickTransfer = () => {

  }

  const filterBox = () => {
    const filtered = stockage.filter((a) => {
      return a.boxName.toLowerCase().includes(filterValue.toLowerCase())
    })
    setFilteredStockage(filtered);
  }

  useEffect(() => {
    if (filterValue) {
      filterBox();
    } else {
      setFilteredStockage(stockage);
    }
  }, [filterValue]);

  return (
    <div className="p-4">
      <h1 className="text-3xl font-bold mb-8">Stockage</h1>
      
      <div className="mb-4">
        <input
          type="text"
          placeholder="Recherche"
          value={filterValue || ''}
          onChange={(event) => setFilterValue(event.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <AddBoxDialog buttonText="+ Boîte" addBox={addBox} setAddBox={setAddBox} />

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 mt-8">
        {filteredStockage.map((data) => {
          const stockedObjects = (data.annonces) ? data.annonces.filter((a) => {
            return a.status === 'TROUVÉ'
          }) : [];
        
          return (
            <div key={data.id} className="flex flex-col items-center">
              <div 
                onClick={() => handleClick(data.id)}
                className="relative cursor-pointer group"
              >
                <div className="relative">
                  <InboxStackIcon 
                    className={`w-24 h-24 ${data.boxName.includes('Esp.') ? 'text-gray-400' : 'text-[#1b9faa]'} group-hover:opacity-80 transition-opacity`}
                  />
                  {stockedObjects.length > 0 && (
                    <span className={`absolute top-3 left-1/2 transform -translate-x-1/2 text-xl font-bold ${data.boxName.includes('Esp.') ? 'text-gray-400' : 'text-[#1b9faa]'}`}>
                      {stockedObjects.length}
                    </span>
                  )}
                </div>
              </div>
              <span className="mt-2 text-sm text-gray-600">{data.boxName}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stockage;
